import React, {useEffect, useRef, useState} from "react";
import {Toast} from "../components/Toast/Toast";

const DEFAULT_DURATION_MS = 2500;

// useToastProvider - управляет показом тостов и их авто-закрытием
export const useToastProvider = () => {
    const [toast, setToast] = useState(null);
    const timerRef = useRef(null);

    // Очистка таймера при размонтировании
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    // Закрывает текущий тост и сбрасывает таймер
    const closeToast = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setToast(null);
    };

    // Показывает тост с текстом и типом, автоматически закрывая через время
    const showToast = (text, type = "info", durationMs = DEFAULT_DURATION_MS) => {
        if (!text) return;

        setToast(
            <Toast
                text={text}
                type={type}
                onClose={closeToast}
            />
        );

        if (durationMs > 0) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                closeToast();
            }, durationMs);
        }
    };

    // Показывает тост с ошибкой
    const showErrorToast = (text) => showToast(text, "error");

    // Показывает тост с успешным действием
    const showSuccessToast = (text) => showToast(text, "success");

    return {
        toast,
        toastContext: {
            showToast,
            showErrorToast,
            showSuccessToast,
        },
    };
};
